import React, { FC, SVGProps } from "react";

export const IconSwap: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 21 20" fill="none" {...props}>
      <g clipPath="url(#clip0_2996_29827)">
        <path
          d="M10.4999 4.99967V7.49967L13.8333 4.16634L10.4999 0.833008V3.33301C6.81659 3.33301 3.83325 6.31634 3.83325 9.99967C3.83325 11.308 4.21659 12.5247 4.86659 13.5497L6.08325 12.333C5.70825 11.6413 5.49992 10.8413 5.49992 9.99967C5.49992 7.24134 7.74159 4.99967 10.4999 4.99967ZM16.1333 6.44967L14.9166 7.66634C15.2833 8.36634 15.4999 9.15801 15.4999 9.99967C15.4999 12.758 13.2583 14.9997 10.4999 14.9997V12.4997L7.16659 15.833L10.4999 19.1663V16.6663C14.1833 16.6663 17.1666 13.683 17.1666 9.99967C17.1666 8.69134 16.7833 7.47467 16.1333 6.44967Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2996_29827">
          <rect
            width="20"
            height="20"
            fill="currentColor"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
